export default function EventHandler$resolve ( index, keypath ) {
	this.keypaths[ index ] = keypath;
}
